module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-2-dd89c787f3dd07d65344ae6140665e3d.png";